import React from 'react'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Contact from './components/Contact';
import { BrowserRouter } from 'react-router-dom';
import Content from './components/Content';

const App = () => {
    return (
        <BrowserRouter>
            <Content />
            <Contact />
            <ToastContainer theme='dark' position='top-center' />
        </BrowserRouter>
    )
}

export default App
